import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { InfoIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { useLocalStorage } from '../../local-storage/hooks/useLocalStorage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IDENTIFY_CONTACT_TOOLTIP_HIDDEN = 'IDENTIFY_CONTACT_TOOLTIP_HIDDEN';
const IdentifyContactWarning = ({
  vid
}) => {
  const [item, setItem] = useLocalStorage({
    key: IDENTIFY_CONTACT_TOOLTIP_HIDDEN,
    initialValue: JSON.stringify({
      [vid]: false
    })
  });
  const getIsClosed = useCallback(() => {
    try {
      return JSON.parse(item)[vid];
    } catch (e) {
      return false;
    }
  }, [item, vid]);
  const setHidden = useCallback(() => setItem(JSON.stringify(Object.assign({}, JSON.parse(item), {
    [vid]: true
  }))), [item, setItem, vid]);
  return getIsClosed() ? null : /*#__PURE__*/_jsx(Alert, {
    type: "tip",
    use: "inline",
    closeable: true,
    onClose: setHidden,
    marginBlockStart: "200",
    marginBlockEnd: "400",
    padding: "200",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      gap: "100",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.crm-integration.IdentifyContactTip.alert",
          useGap: true
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom left",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.crm-integration.IdentifyContactTip.tooltip"
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {
          size: "300",
          color: "icon-core-subtle"
        })
      })]
    })
  });
};
IdentifyContactWarning.displayName = 'IdentifyContactWarning';
export default IdentifyContactWarning;